import { inject, Service } from '@angular/core'
import { FirebaseAnalyticsService } from './firebase-analytics.service'
import { captureException } from '../helpers/error-capture.helper'
import { WindowService } from './window.service'

@Service()
export class YoutubeService {
  private firebaseAnalyticsService = inject(FirebaseAnalyticsService)
  private windowService = inject(WindowService)

  init(): void {
    this.startWebWorkerYoutubeTracking()
  }

  startWebWorkerYoutubeTracking(): void {
    const window = this.windowService.nativeWindow()
    window.addEventListener('message', (event: MessageEvent) => {
      if (event.data?.name === 'youtube-play' || event.data?.name === 'youtube-ended') {
        const { name, action, videoTitle } = event.data
        this.firebaseAnalyticsService
          .trackEvent(name, {
            action,
            video: videoTitle,
          })
          .catch((error) => {
            captureException(error, 'error', 'youtube-track-play-webworker')
          })
      }
    })
  }
}
